module.exports = __webpack_public_path__ + "img/progress-2.45d555a1.svg";